module.exports = __webpack_public_path__ + "img/chevrons-down.c6b3b8ec.svg";